import { GenericModelApi } from "./GenericModelApi";
import { ProductCostLogFormData } from "@/formTypes/ProductCostLogFormDataType";
import { getTenantId, getUserData } from "@utils/Auth";
import { ApiSchema, ApiError, FetchResponse } from "@/api/ApiClient";
import { getCurrentDateTime } from "@utils/Api";

export type ProductCostLogDataType = Partial<ApiSchema["ProductCostLog"]["type"] & ProductCostLogFormData>;
class Api extends GenericModelApi<"ProductCostLog", ProductCostLogDataType> {

    async createProductCostLog(providerId: string, productId: string, cost: number): Promise<ProductCostLogDataType> {
        const { email: userEmail, name = "" } = await getUserData()
        const log: ProductCostLogDataType = {
            cost,
            created: getCurrentDateTime(),
            productId,
            providerId,
            user: name,
            userEmail
        }
        return await this.create(log)
    }

    async getCostMovementByProduct(
        productId: string,
    ): Promise<FetchResponse<ProductCostLogDataType>> {
        const tenantId = await getTenantId();

        const fetchFunction = this.model.listProductCostLogByTenant;
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            productIdCreatedAt: {
                beginsWith: {
                    productId,
                    createdAt: ""
                }
            }
        }, {
            limit: 100,
            sortDirection: "DESC"
        });

        if (errors) {
            throw new ApiError("Error al obtener el product por codigo", "API_ERROR", errors);
        }

        return {
            items: data,
            nextToken: nt
        }
    }
}
export const ProductCostLogApi = new Api("ProductCostLog", "createdAt")